module.exports = __webpack_public_path__ + "img/prompt_bg_loan.e2ed3111.svg";